import ProposalCard from './ProposalCard';
export default ProposalCard;
